<template>
  <a-collapse id="report-summary-card" :activeKey="['1','2','3','4']" :bordered="false">
    <template v-slot:expandIcon="props">
      <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
    </template>
    <a-collapse-panel header="Course Details" key="1">
      <a-card size="small" hoverable style="width: 100%" :loading="! courseDetails.post_meta">
        <a-card size="small" title="Course package name:">
          <span slot="extra" v-if="courseDetails.post_meta">
            {{courseDetails.post_meta.coursePackageName[0]}}
          </span>
        </a-card>
        <a-card size="small" title="Course package type:" :style="{ marginTop: '16px' }">
          <span slot="extra" v-if="courseDetails.post_meta">
            {{courseDetails.post_meta.coursePackageType[0]}}
          </span>
        </a-card>
        <a-card size="small" title="Course package identifier:" :style="{ marginTop: '16px' }">
          <span slot="extra" v-if="courseDetails.post_meta">
            {{courseDetails.post_meta.coursePackageIdentifier[0]}}
          </span>
        </a-card>
        <a-card size="small" title="Course module identifier:" :style="{ marginTop: '16px' }">
          <span slot="extra" v-if="courseDetails.post_meta">
            {{courseDetails.post_meta.courseModuleIdentifier[0]}}
          </span>
        </a-card>
        <a-card size="small" title="Study Area:" :style="{ marginTop: '16px' }">
          <span slot="extra" v-if="courseDetails.post_meta">
            {{courseDetails.post_meta.studyLevel[0]}}
          </span>
        </a-card>
        <a-card size="small" title="Course Level:" :style="{ marginTop: '16px' }">
          <span slot="extra" v-if="courseDetails.post_meta">
            {{courseDetails.post_meta.courseLevel[0]}}
          </span>
        </a-card>
        <a-card size="small" title="Institution name:" :style="{ marginTop: '16px' }">
          <span slot="extra" v-if="courseDetails.post_meta">
            {{courseDetails.post_meta.institutionName[0]}}
          </span>
        </a-card>
        <a-card size="small" title="Faculty/Dept:" :style="{ marginTop: '16px' }">
          <span slot="extra" v-if="courseDetails.post_meta">
            {{courseDetails.post_meta.facultyDept[0]}}
          </span>
        </a-card>
        <a-card size="small" title="Formal accreditation request:" :style="{ marginTop: '16px' }">
          <span slot="extra" v-if="courseDetails.post_meta">
            {{courseDetails.post_meta.submitForAccreditation[0]}}
          </span>
        </a-card>
        <a-card size="small" title="Course submitted date:" :style="{ marginTop: '16px' }">
          <span slot="extra" v-if="courseDetails.post_meta">
            {{courseDetails.post_meta.courseSubmissionDateString[0]}}
          </span>
        </a-card>
      </a-card>
    </a-collapse-panel>
    <a-collapse-panel header="Combined Review Details" key="2" v-if="!isComparative && (courseDetails.post_meta && courseDetails.post_meta.combined_review_commencement_date)">
      <a-card size="small" hoverable style="width: 100%" :loading="! courseDetails.post_meta">
        <a-card size="small" title="Review start date:" v-if="courseDetails.post_meta && courseDetails.post_meta.combined_review_commencement_date">
          <span slot="extra" v-if="courseDetails.post_meta">
            {{courseDetails.post_meta.combined_review_commencement_date[0]}}
          </span>
        </a-card>
        <a-card size="small" title="Review end date:" :style="{ marginTop: '16px' }" v-if="courseDetails.post_meta && courseDetails.post_meta.combined_review_completion_date">
          <span slot="extra" v-if="courseDetails.post_meta">
            {{courseDetails.post_meta.combined_review_completion_date[0]}}
          </span>
        </a-card>
      </a-card>
    </a-collapse-panel>
    <a-collapse-panel header="Assessed Totals (per domain)" key="3" v-if="!isComparative && accreditationCalcDetail && accreditationCalcDetail.calc">
      <a-card size="small" id="report-summary" hoverable style="width: 100%" :loading="!(accreditationCalcDetail && accreditationCalcDetail.calc)">
        <a-card size="small" title="Online Environment" :style="{ marginTop: '16px' }" v-if="accreditationCalcDetail.calc">
          <span slot="extra"><a-icon type="crown" theme="twoTone" :twoToneColor="accreditationCalcDetail.calc.first.badge.toLowerCase()"/>
          {{accreditationCalcDetail.calc.first.badge}} <span v-if="userRole === 'telas_telas_administrator'"><b>({{ accreditationCalcDetail.calc.first.badge_level }})</b></span></span>
        </a-card>
        <a-card size="small" title="Learner Support" :style="{ marginTop: '16px' }" v-if="accreditationCalcDetail.calc">
          <span slot="extra"><a-icon type="crown" theme="twoTone" :twoToneColor="accreditationCalcDetail.calc.second.badge.toLowerCase()" />
          {{accreditationCalcDetail.calc.second.badge}} <span v-if="userRole === 'telas_telas_administrator'"><b>({{ accreditationCalcDetail.calc.second.badge_level }})</b></span></span>
        </a-card>
        <a-card size="small" title="Learning & Assessment Tasks" :style="{ marginTop: '16px' }" v-if="accreditationCalcDetail.calc">
          <span slot="extra"><a-icon type="crown" theme="twoTone" :twoToneColor="accreditationCalcDetail.calc.third.badge.toLowerCase()" />
          {{accreditationCalcDetail.calc.third.badge}} <span v-if="userRole === 'telas_telas_administrator'"><b>({{ accreditationCalcDetail.calc.third.badge_level }})</b></span></span>
        </a-card>
        <a-card size="small" title="Learning Resources" :style="{ marginTop: '16px' }" v-if="accreditationCalcDetail.calc">
          <span slot="extra"><a-icon type="crown" theme="twoTone" :twoToneColor="accreditationCalcDetail.calc.fourth.badge.toLowerCase()" />
          {{accreditationCalcDetail.calc.fourth.badge}} <span v-if="userRole === 'telas_telas_administrator'"><b>({{ accreditationCalcDetail.calc.fourth.badge_level }})</b></span>
          </span>
        </a-card>
      </a-card>
    </a-collapse-panel>
    <a-collapse-panel header="Assessed Total (overall)" key="4" v-if="!isComparative && accreditationCalcDetail && accreditationCalcDetail.calc">
      <a-card size="small" id="report-summary" hoverable style="width: 100%" :loading="! (accreditationCalcDetail && accreditationCalcDetail.calc)">
        <a-card size="small" title="Eligible Accreditation Badge">
          <span slot="extra" v-if="accreditationCalcDetail.calc"><a-icon type="crown" theme="twoTone" :twoToneColor="accreditationCalcDetail.calc.accreditation_badge.toLowerCase()" style="font-size: 30px;" />
            {{accreditationCalcDetail.calc.accreditation_badge}}
          </span>
        </a-card>
      </a-card>
    </a-collapse-panel>
  </a-collapse>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'report-summary',
  props: [
    'reportId',
    'courseDetails',
    'isComparative',
  ],
  
  computed: {
    ...mapGetters("user", {
      userRole: "getUserRole",
      userToken: "getUserToken",
    }),
    ...mapState('reports', {
      accreditationCalcDetail: state => state.accreditationCalcDetail,
    }),
  },
  methods: {
    ...mapActions('reports', {
      getAccreditationByReportId: 'getAccreditationByReportId',
    }),
  },
  mounted() {
    this.getAccreditationByReportId(this.reportId);
  },
};
</script>
<style>
#report-summary-card.ant-collapse-borderless > .ant-collapse-item {
  border-bottom: unset;
}
#report-summary-card .ant-collapse-header {
  font-size: 20px !important;
}
</style>
